/** Ledger rows use amount_rupees; old Bavix rows use amount in paise. */
export function formatBonusAmount(item) {
  if (!item) {
    return '0.00';
  }
  if (item.amount_rupees != null && item.amount_rupees !== '') {
    return parseWalletAmount(item.amount_rupees).toFixed(2);
  }
  if (item.apm_comm_amount != null && item.apm_comm_amount !== '') {
    return parseWalletAmount(item.apm_comm_amount).toFixed(2);
  }
  return (parseWalletAmount(item.amount) / 100).toFixed(2);
}

/** Parse API wallet amounts that may be numbers or Indian-formatted strings ("1,234.56"). */
export function parseWalletAmount(value, fallback = 0) {
  if (value == null || value === '') {
    return fallback;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : fallback;
  }
  const parsed = parseFloat(String(value).replace(/,/g, ''));
  return Number.isFinite(parsed) ? parsed : fallback;
}
